<script>
export default {
  name: "fullQuestionEditorModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "visible",
    event: "visible",
  },
  data() {
    return {
      form: {
        score: 0,
        isrqe: true,
        maxlength: 1,
        rightkey: "",
      },
    };
  },
  methods: {
    modalOk() {
      const input = `<input type="text" data-maxlenth="1" data-score="0" data-rightkey="1" data-isrqe="true" style="border-width: 0px 0px 1px; border-top-style: initial; border-right-style: initial; border-left-style: initial; border-color: initial; border-bottom-style: solid;"/>`;
      const html = input.replace(/data-score="[^"]+"/, `data-score="${this.form.score}"`)
        .replace(/data-isrqe="[^"]+"/, `data-isrqe="${this.form.isrqe}"`)
        .replace(/data-maxlenth="[^"]+"/, `data-maxlenth="${this.form.maxlength}"`)
        .replace(/data-rightkey="[^"]+"/, `data-rightkey="${this.form.rightkey}"`);
      this.$emit("visible", false);
      this.$emit("ok", html);
    },
    modalCancel() {
      this.$emit("visible", false);
      this.form = {
        score: 0,
        isrqe: true,
        maxlength: 1,
        rightkey: "",
      };
    },
  },
};
</script>

<template>
  <a-modal title="填空" :visible="visible" @ok="modalOk" @cancel="modalCancel" width="800px" centered>
    <a-form-model :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
      <a-form-model-item label="最多填写">
        <a-input-number v-model="form.maxlength" type="number" :min="0" :max="9999" :step="1" />
      </a-form-model-item>
      <a-form-model-item label="分值">
        <a-input-number v-model="form.score" type="number" :min="0" :max="9999" :step="1" />
      </a-form-model-item>
      <a-form-model-item label="正确答案">
        <a-input v-model="form.rightkey" type="text" :maxLength="35" />
      </a-form-model-item>
      <a-form-model-item label="必填">
        <a-checkbox :checked="form.isrqe" @change="e => form.isrqe = e.target.checked" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<style scoped lang="less">

</style>
